/* Guía del coco (blog.guia y article.guia). Todo el contenido está en el HTML: este archivo solo le da movimiento.
   Es idempotente: si la sección se vuelve a cargar en el editor del tema, no duplica nada. */
(function () {
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function norm(t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }

  var avisoT;
  function aviso(t) {
    var a = $('.cyg .aviso'); if (!a) return;
    a.textContent = t; a.hidden = false; clearTimeout(avisoT); avisoT = setTimeout(function () { a.hidden = true; }, 3200);
  }

  /* ---- tamaño de letra ---- */
  var ESCALAS = [1, 1.125, 1.25, 1.4], paso = 0;
  try { paso = +localStorage.getItem('cyg-letra') || 0; } catch (e) {}
  function letra(d) {
    paso = Math.max(0, Math.min(ESCALAS.length - 1, paso + d));
    $$('.cyg').forEach(function (n) { n.style.setProperty('--cyg-escala', ESCALAS[paso]); });
    try { localStorage.setItem('cyg-letra', paso); } catch (e) {}
  }

  /* ---- escuchar ---- */
  var voz = 'speechSynthesis' in window ? window.speechSynthesis : null, hablando = false;
  function callar() {
    if (voz) voz.cancel(); hablando = false;
    $$('.cyg .oir').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); $('span', b).textContent = 'Escuchar'; });
  }
  function textoDe(n) {
    if (n.tagName === 'TR') return $$('th,td', n).map(function (c) { var b = $('b', c); return (b || c).textContent.trim(); }).join(': ');
    return n.textContent.trim();
  }
  function leer(boton) {
    if (hablando) { callar(); return; }
    var art = boton.closest('.art'), partes = [$('h1', art).textContent];
    var corta = $('.corta p', art); if (corta) partes.push(corta.textContent);
    $$('.cuerpo h2, .cuerpo h3, .cuerpo p, .cuerpo li, .cuerpo tbody tr, .cuerpo summary', art).forEach(function (n) {
      if (n.closest('.no-leer, .hoja-pie, .indice, .prod, .sigue, .eje, .leyenda, .fuentes, .presets, .rango') || n.querySelector('.btn')) return;
      var t = textoDe(n); if (t) partes.push(t);
    });
    var frases = partes.join('. ').replace(/\s+/g, ' ').match(/[^.!?…]+[.!?…]*/g) || [];
    var vs = voz.getVoices().filter(function (v) { return /^es/i.test(v.lang); });
    var v = vs.filter(function (x) { return /CO|MX|US|419/i.test(x.lang); })[0] || vs[0];
    hablando = true; boton.setAttribute('aria-pressed', 'true'); $('span', boton).textContent = 'Detener';
    frases.forEach(function (f, i) {
      var u = new SpeechSynthesisUtterance(f.trim()); u.lang = v ? v.lang : 'es-CO'; if (v) u.voice = v; u.rate = .95;
      if (i === frases.length - 1) u.onend = callar; voz.speak(u);
    });
  }

  /* ---- buscador de la portada ---- */
  function buscador() {
    var campo = $('#cyg-buscar'), datos = $('#cyg-indice'); if (!campo || !datos || campo.dataset.listo) return;
    campo.dataset.listo = '1';
    var indice = []; try { indice = JSON.parse(datos.textContent); } catch (e) {}
    var lista = $('#cyg-lista'), res = $('#cyg-resultados'), pag = $('#cyg-paginas'), cuenta = $('#cyg-cuenta'), cuenta0 = cuenta ? cuenta.textContent : '';
    campo.addEventListener('input', function () {
      var q = norm(campo.value.trim());
      if (!q) { res.hidden = true; res.innerHTML = ''; lista.hidden = false; if (pag) pag.hidden = false; if (cuenta) cuenta.textContent = cuenta0; return; }
      var l = indice.filter(function (a) { return norm(a.t + ' ' + a.c + ' ' + a.e).indexOf(q) > -1; });
      res.innerHTML = l.length ? l.map(function (a) {
        var clase = norm(a.e).replace(/[^a-z0-9]+/g, '-').split('-')[0];
        return '<a class="tarj c-' + clase + '" href="' + esc(a.u) + '">' + (a.e ? '<span class="cat" style="width:fit-content">' + esc(a.e) + '</span>' : '') + '<h3>' + esc(a.t) + '</h3>' + (a.c ? '<p>' + esc(a.c) + '</p>' : '') + '<span class="pie"><span></span><span class="ir">Leer</span></span></a>';
      }).join('') : '<p class="vacio" style="grid-column:1/-1">No encontramos artículos con esa búsqueda. Prueba con otra palabra.</p>';
      res.hidden = false; lista.hidden = true; if (pag) pag.hidden = true;
      if (cuenta) cuenta.textContent = l.length + (l.length === 1 ? ' artículo' : ' artículos');
    });
  }

  /* ---- dato del día ---- */
  function dato(caja) {
    if (caja.dataset.listo) return; caja.dataset.listo = '1';
    var datos = $$('.dato-cuerpo', caja), i = 0, b = $('[data-otro]', caja); if (!b || datos.length < 2) return;
    b.addEventListener('click', function () { datos[i].hidden = true; i = (i + 1) % datos.length; datos[i].hidden = false; });
  }

  /* ---- piezas dentro de los artículos ---- */
  function barras(p) {
    var nota = $('.nota', p), bs = $$('.barra', p);
    function elegir(b) {
      bs.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      if (nota) nota.innerHTML = '<b>' + esc($('span', b).textContent) + ':</b> ' + esc(b.dataset.nota || '');
    }
    bs.forEach(function (b) { b.addEventListener('click', function () { elegir(b); }); });
    if (bs[0]) elegir($('.barra[aria-pressed="true"]', p) || bs[0]);
  }
  function termo(p) {
    var r = $('input[type=range]', p); if (!r) return;
    var umbral = +p.dataset.umbral || 22, sol = $('[data-estado="solido"]', p), liq = $('[data-estado="liquido"]', p), o = $('output', p), e = $('.termo-lec b', p), n = $('[data-nota]', p);
    function pintar() {
      var t = +r.value, l = t >= umbral;
      if (o) o.textContent = t + ' °C';
      if (e) { e.textContent = l ? 'Líquido y transparente' : 'Sólido y blanco'; if (l) e.setAttribute('data-liq', ''); else e.removeAttribute('data-liq'); }
      if (sol && liq) { if (l) { sol.setAttribute('data-off', ''); liq.removeAttribute('data-off'); } else { liq.setAttribute('data-off', ''); sol.removeAttribute('data-off'); } }
      if (n) n.textContent = l ? n.dataset.liquido : n.dataset.solido;
    }
    r.addEventListener('input', pintar); pintar();
  }
  function conv(p) {
    var g = $('input[type=number]', p), o = $('[data-ml]', p), f = +p.dataset.factor || 1.09; if (!g || !o) return;
    function pintar() {
      var v = Math.max(0, Math.min(20000, +g.value || 0)), ml = v * f; ml = ml >= 1000 ? Math.round(ml / 10) * 10 : Math.round(ml);
      o.textContent = ml.toLocaleString('es-CO');
      $$('[data-g]', p).forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.g === v)); });
    }
    g.addEventListener('input', pintar);
    $$('[data-g]', p).forEach(function (b) { b.addEventListener('click', function () { g.value = b.dataset.g; pintar(); }); });
    pintar();
  }
  function hojas(p) {
    var hs = $$('.hoja', p), temas = [], nombres = {};
    hs.forEach(function (h) {
      var t = h.dataset.tema; if (t && temas.indexOf(t) < 0) { temas.push(t); nombres[t] = h.dataset.temaNombre || t; }
      var pie = $('.hoja-pie', h);
      if (pie && !$('.copiar', pie)) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'copiar'; b.textContent = 'Copiar';
        b.addEventListener('click', function () {
          var f = $('.hoja-pie span', h), txt = $('h3', h).textContent.trim() + '. ' + $('.hoja-c > p', h).textContent.trim() + (f ? ' (' + f.textContent.trim() + ')' : '') + ' · cocosymas.co';
          try { navigator.clipboard.writeText(txt).then(function () { aviso('Copiado. Ya lo puedes pegar en WhatsApp.'); }, function () { aviso('No se pudo copiar desde este navegador.'); }); } catch (e) { aviso('No se pudo copiar desde este navegador.'); }
        });
        pie.appendChild(b);
      }
    });
    if (temas.length < 2) return;
    var chips = document.createElement('div'); chips.className = 'chips ancha no-leer'; chips.setAttribute('role', 'group'); chips.setAttribute('aria-label', 'Filtrar');
    chips.innerHTML = '<button type="button" class="chip" data-t="" aria-pressed="true">Las ' + hs.length + '</button>' + temas.map(function (t) { return '<button type="button" class="chip" data-t="' + esc(t) + '" aria-pressed="false">' + esc(nombres[t]) + '</button>'; }).join('');
    chips.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      $$('button', chips).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      hs.forEach(function (h) { h.hidden = !!b.dataset.t && h.dataset.tema !== b.dataset.t; });
    });
    p.parentNode.insertBefore(chips, p);
  }
  var PIEZAS = { barras: barras, termo: termo, conv: conv, hojas: hojas, dato: dato };

  function iniciar() {
    letra(0);
    buscador();
    $$('.cyg [data-cyg]').forEach(function (p) { if (p.dataset.cygListo) return; p.dataset.cygListo = '1'; var f = PIEZAS[p.dataset.cyg]; if (f) f(p); });
    $$('.cyg .util').forEach(function (u) {
      if (u.dataset.listo) return; u.dataset.listo = '1';
      var o = $('.oir', u); if (o && voz) o.hidden = false;
      u.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; if (b.dataset.letra) letra(+b.dataset.letra); else if (b.classList.contains('oir')) leer(b); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
  window.addEventListener('pagehide', callar);
})();
